export const PLATFORMS = {
  os: 'user_data_platform',
  ios: 'IOS_WEB',
  android: 'ANDROID_WEB',
  'mac os': 'DESKTOP_WEB',
  linux: 'DESKTOP_WEB',
};
